/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_MediumInputs */

const en_field_medium = /** @type {(inputs: Field_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium`)
};

const es_field_medium = /** @type {(inputs: Field_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medio / Técnica`)
};

const fr_field_medium = /** @type {(inputs: Field_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Médium`)
};

const de_field_medium = /** @type {(inputs: Field_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium`)
};

const ja_field_medium = /** @type {(inputs: Field_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディア / 素材`)
};

const zh_field_medium = /** @type {(inputs: Field_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒介`)
};

const ar_field_medium = /** @type {(inputs: Field_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوسيط (الخامة)`)
};

const id_field_medium = /** @type {(inputs: Field_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium`)
};

const it_field_medium = /** @type {(inputs: Field_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Materiale / Tecnica`)
};

const ru_field_medium = /** @type {(inputs: Field_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Материалы/Техника`)
};

const pt_field_medium = /** @type {(inputs: Field_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meio (Técnica)`)
};

const ko_field_medium = /** @type {(inputs: Field_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`매체 / 기법`)
};

/**
* | output |
* | --- |
* | "Medium" |
*
* @param {Field_MediumInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_medium = /** @type {((inputs?: Field_MediumInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_MediumInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_medium(inputs)
	if (locale === "es") return es_field_medium(inputs)
	if (locale === "fr") return fr_field_medium(inputs)
	if (locale === "de") return de_field_medium(inputs)
	if (locale === "ja") return ja_field_medium(inputs)
	if (locale === "zh") return zh_field_medium(inputs)
	if (locale === "ar") return ar_field_medium(inputs)
	if (locale === "id") return id_field_medium(inputs)
	if (locale === "it") return it_field_medium(inputs)
	if (locale === "ru") return ru_field_medium(inputs)
	if (locale === "pt") return pt_field_medium(inputs)
	return ko_field_medium(inputs)
});